import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeSlug from 'rehype-slug';
import rehypeRaw from 'rehype-raw';
import Lottie from 'lottie-react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';
import Footer from "./Footer";
import './HelpPage.css';

const LottieWrapper = ({ src, className }) => {
  const [animData, setAnimData] = useState(null);

  useEffect(() => {
    fetch(src)
      .then(res => res.json())
      .then(setAnimData)
      .catch(err => console.error("Error loading Lottie animation:", err));
  }, [src]);

  if (!animData) {
    return <div className={className} style={{ height: '200px', backgroundColor: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>Loading Animation...</div>;
  }

  return (
    <div className={className} style={{ overflow: 'hidden' }}>
      <Lottie animationData={animData} loop={true} autoplay={true} />
    </div>
  );
};

const HelpPage = () => {
  const [content, setContent] = useState('');

  useEffect(() => {
    fetch('/HelpScreen.md')
      .then((response) => {
        if (!response.ok) {
          throw new Error('Failed to load the Markdown file');
        }
        return response.text();
      })
      .then((text) => setContent(text))
      .catch((error) => {
        console.error('Error loading Markdown:', error);
        setContent('Help content could not be loaded at this time.');
      });
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ fontFamily: 'Arial, sans-serif', lineHeight: 1.6, margin: '20px', maxWidth: '800px' }}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeSlug, rehypeRaw]} // Enables HTML rendering
        components={{
          img: ({ node, ...props }) => {
            if (props.src && props.src.endsWith('.json')) {
              return <LottieWrapper src={props.src} className={props.className} />;
            }
            if (props.src && props.src.endsWith('.lottie')) {
              return (
                <div className={props.className} style={{ overflow: 'hidden', aspectRatio: '9/16' }}>
                  <DotLottieReact src={props.src} loop={true} autoplay={true} style={{ width: '100%', height: '100%' }} />
                </div>
              );
            }
            return <img alt={props.alt || ""} {...props} />;
          }
        }}
      >
        {content}
      </ReactMarkdown>
      <Footer />
    </div>
  );
};

export default HelpPage;
